module.exports = __webpack_public_path__ + "img/file-ppt-fill.39bdedcd.svg";